export enum PaymentRequestType {
  private = 'private',
  business = 'business'
}
